import React from 'react';
import ReactDOM from 'react-dom/client';
import { BaseCSS } from 'styled-bootstrap-grid';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import App from './App';
import { HomePage } from './components/home-page/home-page';
import { LoginForm } from './components/login/login';
import { ErrorPage } from './components/error-page/error-page';
import { TeamEntry } from './components/tournament-admin/ryder-cup/team-create';
import reportWebVitals from './reportWebVitals';
import { CourseAdmin } from './components/courses/course-admin';
import { PlayerAdmin } from './components/players/player-admin';
import { CreateMatch } from './components/match-entry/create-match-scores';
import { TeamNames } from './components/team-name-admin/team-names';
import { EditResultsNavigation } from './components/results/ryderCup/edit-result-navigation';
import { ResultEditEntry } from './components/match-entry/quick-result-entry/result-edit-entry';
import { AddScoreCard } from './components/match-entry/result-entry/ryder-cup/add-scorecard';
import { CreateTournament } from './components/tournament-admin/create-tournament';
import { CreateTeamGameMatch } from './components/match-entry/create-team-game-match';
import { EnterTeamGameScoreCard } from './components/match-entry/result-entry/team-games/enter-team-game-scorecard';
import { EdtTeamGameMatch } from './components/match-entry/result-entry/team-games/edit-team-game-match';
import { ArchiveTournament } from './components/tournament-admin/archive-tournament';
import { EnterTeamGameMatchPlayScoreCard } from './components/match-entry/result-entry/team-games/enter-team-matchplay-scorecard';
import { TourGroup } from './components/home-page/tour-group';
import { TeeBookingPlayers } from './components/booking-tee-time/tee-booking-players';
import { ItineraryPage } from './components/itinerary/itinerary';

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      { index: true, element: <HomePage /> },
      {
        path: 'tour-group/:group',
        element: <TourGroup />,
      },
      {
        path: '/create-tournament/:year',
        element: <CreateTournament />,
      },
      {
        path: '/archive-tournament/',
        element: <ArchiveTournament />,
      },
      {
        path: '/itinerary',
        element: <ItineraryPage />,
      },
      {
        path: '/previous-tour/:previousTournamentIndex',
        element: <HomePage />,
      },
      {
        path: '/edit-results/:tournamentIndex/:dayIndex',
        element: <EditResultsNavigation />,
      },
      {
        path: '/quick-results/:tournamentIndex/:dayIndex',
        element: <ResultEditEntry />,
      },
      {
        path: '/quick-results/:tournamentIndex/:dayIndex',
        element: <ResultEditEntry />,
      },
      {
        path: '/scorecard/:tournamentIndex/:dayIndex/:matchIndex',
        element: <AddScoreCard />,
      },
      {
        path: '/add-team-game-scorecard/:tournamentIndex/:dayIndex/:teamIndex',
        element: <EnterTeamGameScoreCard editing={false} />,
      },
      {
        path: '/edit-team-game-scorecard/:tournamentIndex/:dayIndex/:teamIndex',
        element: <EnterTeamGameScoreCard editing={true} />,
      },
      {
        path: '/add-team-game-matchplay-scorecard/:tournamentIndex/:dayIndex/:teamIndex',
        element: <EnterTeamGameMatchPlayScoreCard editing={false} />,
      },
      {
        path: '/edit-team-game-matchplay-scorecard/:tournamentIndex/:dayIndex/:teamIndex',
        element: <EnterTeamGameMatchPlayScoreCard editing={true} />,
      },
      {
        path: '/create-teams',
        element: <TeamEntry />,
      },
      {
        path: '/course-admin',
        element: <CourseAdmin />,
      },
      {
        path: '/player-admin',
        element: <PlayerAdmin />,
      },
      {
        path: '/team-admin',
        element: <TeamNames />,
      },
      {
        path: '/add-results',
        element: <CreateMatch />,
      },
      {
        path: '/add-team-game-results',
        element: <CreateTeamGameMatch />,
      },
      {
        path: '/team-game-edit-results/:tournamentIndex/:matchIndex',
        element: <EdtTeamGameMatch />,
      },
      {
        path: '/login',
        element: <LoginForm />,
      },
      {
        path: '/tee-booking-admin',
        element: <TeeBookingPlayers />,
      },
    ],
  },
]);
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const queryClient = new QueryClient();
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <BaseCSS />
    </QueryClientProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
